import {
  ActionNames,
  HostEditActionDefinition,
} from '@wix/editor-platform-host-integration-apis';

import { EditActionsStore } from '../editActionsStore';
import { filterByTags } from '../utils';
import { PlatformContext } from '../types';
import {
  deriveDefaultEditActionsFromManifest,
  getResolvedEditActions,
  customizeNativeActions,
} from './index';
import { groupNativeActions } from './groupNativeActions';

function getNativeEditActions(
  platformContext: PlatformContext,
  tags?: string[],
): HostEditActionDefinition[] {
  const { manifestServicesAPI, editorPointer } = platformContext;

  const derivedEditActions = deriveDefaultEditActionsFromManifest(
    manifestServicesAPI,
    editorPointer,
  );
  const nativeActions = manifestServicesAPI.get.editActions(editorPointer);

  if (!nativeActions) {
    return [];
  }

  const groupedNativeActions = groupNativeActions(nativeActions);
  const nativeActionsNames = Object.keys(
    groupedNativeActions.nativeActions,
  ) as ActionNames[];
  const derivedEditActionNames = Object.keys(
    derivedEditActions,
  ) as ActionNames[];

  const resolvedNativeEditActions =
    getResolvedEditActions<HostEditActionDefinition>(
      EditActionsStore.getStoreSlice([
        ...nativeActionsNames,
        ...derivedEditActionNames,
      ]),
      { ...groupedNativeActions.nativeActions, ...derivedEditActions },
      platformContext,
    );

  const resolvedCustomizedNativeEditActions = Object.values(
    customizeNativeActions(
      groupedNativeActions.customizedNativeActions,
      platformContext,
    ),
  );

  return filterByTags<HostEditActionDefinition>(
    [...resolvedNativeEditActions, ...resolvedCustomizedNativeEditActions],
    tags,
  );
}

export { getNativeEditActions };
